import {deserialize, deserializeAs, serialize, serializeAs} from "libs/cerialize";

export class LifeStatusInfo {
	@deserialize
	Id: number;

	@deserialize
	Name: string;

	@deserialize
	LastStatusDate: Date;

	@deserialize
	Memo: string;

	@deserialize
	MemoTranslation: string;

	Modified: boolean;

	@deserialize
	TranslatedName: string;

	IsCustomStatuses: boolean;

	constructor(name?: string, lastStatusDate?: Date, isCustomStatuses?: boolean) {
		this.Name = name;
		this.LastStatusDate = lastStatusDate;
		this.IsCustomStatuses = isCustomStatuses;
	}
}